import {
  UseSolutionHomePageDataArgs,
  UseSolutionHomePageDataReturn,
} from "./types";
import {
  enrichDynamicTestSetsWithCategory,
  filterDynamicTestSetsByEntriesSession,
  filterEntriesByModule,
} from "../../utils";
import { Module } from "../../../../../constants";
import { calculateCategoryCounts, getTotalFromCategoryCounts } from "./utils";
import { useSolutionJourney } from "./../useSolutionCategoryPageData";

export function useSolutionHomePageData({
  rawData,
  selectedFilters,
  currentTestId,
}: UseSolutionHomePageDataArgs): UseSolutionHomePageDataReturn {
  const entries = rawData?.allEntries ?? [];
  const dynamicTestSets = rawData?.dynamicTestSets ?? [];
  const testSets = rawData?.testSets ?? [];
  const solutionJourney = useSolutionJourney({ testSets, currentTestId });

  const solutionEntries = filterEntriesByModule(
    entries,
    Module.Solution,
    selectedFilters
  );

  const solutionDynamicTestSets = filterDynamicTestSetsByEntriesSession(
    dynamicTestSets,
    solutionEntries,
    Module.Solution
  );

  const dynamicTestSetsWithCategory = enrichDynamicTestSetsWithCategory(
    solutionDynamicTestSets,
    testSets
  );

  const categoryCounts = calculateCategoryCounts(
    solutionEntries,
    dynamicTestSetsWithCategory
  );

  const totalJourneys = getTotalFromCategoryCounts(categoryCounts);

  return {
    cubeValuesByCategory: categoryCounts,
    totalJourneys,
    solutionJourney: solutionJourney.map(sj => ({
      ...sj,
      items: sj.items.map(item => item.label),
    })),
  };
}
